<template>
	<div class="login-bg">
		<div class="bg-color">

			<van-nav-bar class="reg-nav-bar">
				<template #left>
					<div style="width: 86px; height: 32px; margin-left: 15px;" @click="back()">
						<div class="nav-bar__back">
							<span class="tn-icon-left-arrow"></span>
						</div>
					</div>
				</template>
				<template #right>
					<div class="lang-switch-btn" @click="openLanguage">
						<div class="lang-btn-text">
							🌐 {{ langLabel }}
						</div>
					</div>
				</template>
			</van-nav-bar>

			<div class="login-title">
				<div class="title-name">
					<div class="logo-image">
						<img src="/img/login/logo.png" alt="logo" />
					</div>
				</div>
			</div>

			<div class="form">
				<div class="input">
					<span class="tn-icon-my-reduce"></span>
					<input v-model="username" type="text" :placeholder="$t('common.username')" />
				</div>
				<div class="input">
					<span class="tn-icon-lock"></span>
					<input v-model="password" :type="passwordType" :placeholder="$t('auth.login_password')" />
					<div class="ticon" @click="switchPasswordType">
						<span v-if="passwordType === 'password'" class="tn-icon-eye-hide"></span>
						<span v-else class="tn-icon-eye"></span>
					</div>
				</div>
				<div class="input">
					<span class="tn-icon-qr-code"></span>
					<input v-model="inviteCode" type="text" :placeholder="$t('auth.invite_code')" />
				</div>
				<div class="butt" @click="doRegister()">
					<span>{{ $t('auth.register_account') }}</span>
				</div>
				<div class="butt" @click="toLogin()">
					<span>{{ $t('auth.login') }}</span>
				</div>
			</div>

			<Language ref="languagePicker" @change="handleLanguageChange" />
		</div>
	</div>
</template>

<script>
	import http from '@/http/index'
	import Language from '@/common/Language.vue'

	export default {
		name: 'RegisterPage',
		components: {
			Language,
		},
		data() {
			return {
				lang: 'de',
				langLabel: 'Deutsch',
				username: '',
				password: '',
				inviteCode: '',
				agreed: false,
				passwordType: 'password',
				registering: false,
			};
		},

		mounted() {
			this.lang = localStorage.getItem("lang") || 'de';
			this.langLabel = this.getLangLabel(this.lang);
		},

		methods: {
			getLangLabel(code) {
				const labelMap = {
					de: 'Deutsch',
					pt: 'Portugues',
					fr: 'Francais',
					ga: 'Gaeilge',
				};
				return labelMap[code] || labelMap.de;
			},
			openLanguage() {
				this.$refs.languagePicker.open();
			},
			handleLanguageChange(payload) {
				this.lang = payload.code;
				this.langLabel = payload.label;
			},
			// 切换密码显示类型
			switchPasswordType() {
				this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
			},

			// 返回上一页
			back() {
				this.$router.go(-1);
			},
			toLogin() {
				this.$router.push("Login");
			},

			// 表单验证
			validateForm() {
				// 验证用户名
				if (!this.username.trim()) {
					this.$toast.fail(this.$t("auth.username_place"));
					return false;
				}

				// 验证用户名长度和格式
				if (this.username.length < 6 || this.username.length > 20) {
					this.$toast.fail(this.$t("auth.username_rule"));
					return false;
				}

				// 验证密码
				if (!this.password.trim()) {
					this.$toast.fail(this.$t("auth.pwd_place"));
					return false;
				}

				// 验证密码长度
				if (this.password.length < 6 || this.password.length > 16) {
					this.$toast.fail(this.$t("auth.password_rule"));
					return false;
				}

				// 验证邀请码
				// if (!this.inviteCode.trim()) {
				// 	this.$toast.fail(this.$t("auth.invite_code_place"));
				// 	return false;
				// }

				// 验证协议是否同意
				if (!this.agreed) {
					this.$toast.fail(this.$t("auth.please_agree_terms"));
					return false;
				}

				return true;
			},

			// 执行注册
			async doRegister() {
				if (!this.validateForm()) {
					return;
				}

				try {
					this.registering = true;

					const result = await http({
						method: 'post',
						url: 'member_register',
						data: {
							username: this.username.trim(),
							password: this.password.trim(),
							// code: this.inviteCode.trim(),
							lang: this.lang
						}
					});

					if (result && result.code === 200) {
						// 注册成功
						this.$toast.success(this.$t("auth.register_success"));

						// 保存用户ID到本地存储
						if (result.data) {
							localStorage.setItem('userId', result.data);
						}

						// 延迟跳转到登录页面
						setTimeout(() => {
							this.$router.push("/login");
						}, 1500);

					} else {
						// 注册失败
						let errorMsg = result.msg || this.$t("auth.register_failed");

						// 根据错误类型显示不同的提示
						if (result.code === 401) {
							if (errorMsg.includes('用户名已存在') || errorMsg.includes('Username already exists')) {
								errorMsg = this.$t("auth.username_exists");
							} else if (errorMsg.includes('邀请码无效') || errorMsg.includes('Invalid invitation code')) {
								errorMsg = this.$t("auth.invalid_invite_code");
							}
						}

						this.$toast.fail(errorMsg);
					}

				} catch (error) {
					console.error('注册出错:', error);
					this.$toast.fail(`${this.$t("auth.register_failed")} ${error.message}`);
				} finally {
					this.registering = false;
				}
			}
		},

		created() {
			// 如果已经登录，返回上一页
			if (localStorage.getItem('token')) {
				this.$router.go(-1);
			}
		}
	};
</script>

<style lang='less' scoped>
	.login-bg {
		background-image: url(/img/login/login-bg.png);
		background-size: 100% 100%;
		position: relative;
		width: 100%;
		height: 100vh;
	}

	.login-bg .bg-color {
		background: linear-gradient(180deg, #000, #600);
		width: 100%;
		height: 100vh;
	}

	.reg-nav-bar {
		height: 45px;
		background-color: transparent;
	}

	::v-deep .van-nav-bar__content {
		height: 45px;
	}

	::v-deep .van-nav-bar__left,
	::v-deep .van-nav-bar__right {
		padding: 0;
	}

	.nav-bar__back {
		width: 60%;
		height: 100%;
		position: relative;
		display: flex;
		justify-content: space-evenly;
		align-items: center;
		box-sizing: border-box;
		background-color: rgba(0, 0, 0, .15);
		border-radius: 520px;
		border: 0.5px solid hsla(0, 0%, 100%, .5);
		color: #fff;
		font-size: 18px;
	}

	/* .nav-bar__back .tn-icon-left-arrow {
		display: block;
		flex: 1;
		margin: auto;
		text-align: center;
	} */

	.lang-switch-btn {
		display: inline-flex;
		align-items: center;
		padding: 4px 9px;
		background: hsla(0, 0%, 100%, .15);
		border-radius: 15px;
	}

	.lang-switch-btn .lang-btn-text {
		font-size: 13px;
		color: #fff;
		white-space: nowrap;
	}

	::v-deep .van-nav-bar {
		line-height: normal;
	}

	.login-bg .login-title {
		padding: 15px;
	}

	.login-bg .login-title .title-name {
		margin-right: auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.login-bg .login-title .logo-image {
		margin-top: 80px;
		width: 260px;
		height: 72px;
		margin-bottom: 60px;
	}

	.login-bg .login-title .logo-image img {
		width: 100%;
		height: 100%;
	}

	.form {
		margin: 10px;
		padding: 10px;
		height: 364px;
		border-radius: 10px;
	}

	.form .input {
		padding: 10px 20px;
		background-color: #fff;
		border-radius: 26px;
		margin-bottom: 31px;
		margin-right: auto;
		display: flex;
	}

	.form .input input {
		font-size: 16px;
		color: #4b4b4b;

		display: block;
		line-height: 1.4em;
		height: 1.4em;
		min-height: 1.4em;
		overflow: hidden;

		text-align: left;
		border: none;
		outline: none;
		z-index: 2;
		background-color: #fff;
	}

	.form .input input::placeholder {
		font-size: 16px;
	}

	.form .input .tn-icon-my-reduce,
	.form .input .tn-icon-lock {
		display: -webkit-flex;
		display: flex;
		align-self: center;
		font-size: 20px;
		margin-right: 5px;
	}

	.form .input .ticon {
		color: #4b4b4b;
		display: flex;
		align-items: center;
		font-size: 21px;
		margin-left: auto;
	}

	.login-bg .butt {
		margin: 10px;
		border-radius: 52px;
		padding: 10px;
		margin-top: 15px;
		background-image: repeating-linear-gradient(45deg, red, #c00) !important;
	}

	.login-bg .butt span {
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 18px;
	}
</style>
